import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 60px;
`;

const Spinner = styled.div`
  width: 32px;
  height: 32px;
  border: 3px solid ${(props) => props.theme.colors.secondaryBorder};
  border-top-color: ${(props) => props.theme.colors.brand};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export function Loading() {
  return (
    <Wrapper>
      <Spinner />
    </Wrapper>
  );
}
